export default [

     {
          path: '/emergency-equipment-type',
          name: 'EmergencyEquipmentType',
          component: () => import("@/views/Page/EmergencyEquipmentType/EmergencyEquipmentType.vue"),
           meta: {
               title: 'EmergencyEquipmentType',
          },
     }
];